import Request from '@request/Request';

export default class extends Request {
  async submit() {
    try {
      this.beforeSubmit();
      let response = await this.$store.dispatch('auth/login', this.data());
      this.reset();
      if (response) {
        $showSuccess(
          `Welcome back, ${response.data.user.first_name}`,
          'auth-toast'
        );
      }
      return response;
    } catch (error) {
      this.handleError(error);
    }
    this.afterSubmit();
  }
}
